import { render, staticRenderFns } from "./HotwiresDashboardSummary.vue?vue&type=template&id=bbbb16de"
import script from "./HotwiresDashboardSummary.vue?vue&type=script&lang=js"
export * from "./HotwiresDashboardSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports